
export default {
  name: "DataTable",
  props: {
    block: { type: Object, required: true },
  },
  computed: {
    // rows is a JSON field (array of arrays). Guard against a stringified value.
    rows() {
      const r = this.block.rows;
      if (Array.isArray(r)) return r;
      if (typeof r === "string") {
        try {
          return JSON.parse(r);
        } catch (e) {
          return [];
        }
      }
      return [];
    },
  },
};
